/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { expVal } from '@atlassian/jira-feature-experiments';
import { defineMessage } from '@atlassian/jira-intl';
import { L1_MENU_ID, type ConfigurableMenuId } from '../../../common/types.tsx';

const hideFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.hide-from-sidebar',

	defaultMessage: 'Hide from sidebar',
	description: 'Used as the text for the Hide from sidebar menu item',
});

const a11YAlertHideDefaultFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-default-from-sidebar',

	defaultMessage: 'Menu Item have been hidden from the sidebar',
	description:
		'Used as the text for screen-reader to support a11y when the default - menu item gets hidden. This is used when there is no match found.',
});

const a11YHideAppsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-apps-from-sidebar',

	defaultMessage: 'Hide apps from sidebar',
	description:
		'Used as the text for screen-reader to support a11y for the - Hide from sidebar - menu item with added context of a menu id - Apps',
});

const a11YAlertHideAppsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-apps-from-sidebar',

	defaultMessage: 'Apps have been hidden from the sidebar',
	description:
		'Used as the text for screen-reader to support a11y when the apps - menu item gets hidden',
});

const a11YHideAssetsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-assets-from-sidebar',

	defaultMessage: 'Hide assets from sidebar',
	description:
		'Used as the text for screen-reader to support a11y for the - Hide from sidebar - menu item with added context of a menu id - Assets',
});

const a11YAlertHideAssetsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-assets-from-sidebar',

	defaultMessage: 'Assets have been hidden from the sidebar',
	description:
		'Used as the text for screen-reader to support a11y when the assets - menu item gets hidden',
});

const a11YHideDashboardsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-dashboards-from-sidebar',

	defaultMessage: 'Hide dashboards from sidebar',
	description:
		'Used as the text for screen-reader to support a11y for the - Hide from sidebar - menu item with added context of a menu id - Dashboards',
});

const a11YAlertHideDashboardsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-dashboards-from-sidebar',

	defaultMessage: 'Dashboards have been hidden from the sidebar',
	description:
		'Used as the text for screen-reader to support a11y when the dashboards - menu item gets hidden',
});

const a11YHideFiltersFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-filters-from-sidebar',

	defaultMessage: 'Hide filters from sidebar',
	description:
		'Used as the text for screen-reader to support a11y for the - Hide from sidebar - menu item with added context of a menu id - Filters',
});

const a11YAlertHideFiltersFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-filters-from-sidebar',

	defaultMessage: 'Filters have been hidden from the sidebar',
	description:
		'Used as the text for screen-reader to support a11y when the filters - menu item gets hidden',
});

const a11YHideGoalsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-goals-from-sidebar',

	defaultMessage: 'Hide goals from sidebar',
	description:
		'Used as the text for screen-reader to support a11y for the - Hide from sidebar - menu item with added context of a menu id - Goals',
});

const a11YAlertHideGoalsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-goals-from-sidebar',

	defaultMessage: 'Goals have been hidden from the sidebar',
	description:
		'Used as the text for screen-reader to support a11y when the goals - menu item gets hidden',
});

const a11YHideOperationsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-operations-from-sidebar',

	defaultMessage: 'Hide operations from sidebar',
	description:
		'Used as the text for screen-reader to support a11y for the - Hide from sidebar - menu item with added context of a menu id - Operations',
});

const a11YAlertHideOperationsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-operations-from-sidebar',

	defaultMessage: 'Operations have been hidden from the sidebar',
	description:
		'Used as the text for screen-reader to support a11y when the operations - menu item gets hidden',
});

const a11YHidePlansFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-plans-from-sidebar',

	defaultMessage: 'Hide plans from sidebar',
	description:
		'Used as the text for screen-reader to support a11y for the - Hide from sidebar - menu item with added context of a menu id - Plans',
});

const a11YAlertHidePlansFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-plans-from-sidebar',

	defaultMessage: 'Plans have been hidden from the sidebar',
	description:
		'Used as the text for screen-reader to support a11y when the plans - menu item gets hidden',
});

const a11YHideProjectsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-projects-from-sidebar',

	defaultMessage: 'Hide projects from sidebar',
	description:
		'Used as the text for screen-reader to support a11y for the - Hide from sidebar - menu item with added context of a menu id - Projects',
});

const a11YAlertHideProjectsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-projects-from-sidebar',

	defaultMessage: 'Projects have been hidden from the sidebar',
	description:
		'Used as the text for screen-reader to support a11y when the projects - menu item gets hidden',
});

const a11YHideTeamsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-teams-from-sidebar',

	defaultMessage: 'Hide teams from sidebar',
	description:
		'Used as the text for screen-reader to support a11y for the - Hide from sidebar - menu item with added context of a menu id - Teams',
});

const a11YAlertHideTeamsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-teams-from-sidebar',

	defaultMessage: 'Teams have been hidden from the sidebar',
	description:
		'Used as the text for screen-reader to support a11y when the teams - menu item gets hidden',
});

const a11YHideRoadmapsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-roadmaps-from-sidebar',

	defaultMessage: 'Hide roadmaps from sidebar',
	description:
		'Used as the text for screen-reader to support a11y for the - Hide from sidebar - menu item with added context of a menu id - Roadmaps',
});

const a11YAlertHideRoadmapsFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-roadmaps-from-sidebar',

	defaultMessage: 'Roadmaps have been hidden from the sidebar',
	description:
		'Used as the text for screen-reader to support a11y when the roadmaps - menu item gets hidden',
});

const defaultHiddenFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-hidden-from-sidebar',

	defaultMessage: 'Hidden from sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully hidden - default',
});

const appsHiddenFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-hidden-from-sidebar',

	defaultMessage: 'Apps hidden from sidebar',
	description: 'A text that is displayed as a title on a flag when an item is successfully hidden',
});

const assetsHiddenFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-hidden-from-sidebar',

	defaultMessage: 'Assets hidden from sidebar',
	description: 'A text that is displayed as a title on a flag when an item is successfully hidden',
});

const dashboardsHiddenFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-hidden-from-sidebar',

	defaultMessage: 'Dashboards hidden from sidebar',
	description: 'A text that is displayed as a title on a flag when an item is successfully hidden',
});

const goalsHiddenFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-hidden-from-sidebar',

	defaultMessage: 'Goals hidden from sidebar',
	description: 'A text that is displayed as a title on a flag when an item is successfully hidden',
});

const operationsHiddenFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-hidden-from-sidebar',

	defaultMessage: 'Operations hidden from sidebar',
	description: 'A text that is displayed as a title on a flag when an item is successfully hidden',
});

const plansHiddenFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-hidden-from-sidebar',

	defaultMessage: 'Plans hidden from sidebar',
	description: 'A text that is displayed as a title on a flag when an item is successfully hidden',
});

const projectsHiddenFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-hidden-from-sidebar',

	defaultMessage: 'Projects hidden from sidebar',
	description: 'A text that is displayed as a title on a flag when an item is successfully hidden',
});

const teamsHiddenFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-hidden-from-sidebar',

	defaultMessage: 'Teams hidden from sidebar',
	description: 'A text that is displayed as a title on a flag when an item is successfully hidden',
});

const roadmapsHiddenFromSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-hidden-from-sidebar',

	defaultMessage: 'Roadmaps hidden from sidebar',
	description: 'A text that is displayed as a title on a flag when an item is successfully hidden',
});

const defaultMovedBackToSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-moved-back-to-sidebar',

	defaultMessage: 'Moved back to sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully restored - default',
});

const appsMovedBackToSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-moved-back-to-sidebar',

	defaultMessage: 'Apps moved back to sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully restored',
});

const assetsMovedBackToSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-moved-back-to-sidebar',

	defaultMessage: 'Assets moved back to sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully restored',
});

const dashboardsMovedBackToSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-moved-back-to-sidebar',

	defaultMessage: 'Dashboards moved back to sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully restored',
});

const filtersMovedBackToSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.filters-moved-back-to-sidebar',

	defaultMessage: 'Filters moved back to sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully restored',
});

const goalsMovedBackToSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-moved-back-to-sidebar',

	defaultMessage: 'Goals moved back to sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully restored',
});

const operationsMovedBackToSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-moved-back-to-sidebar',

	defaultMessage: 'Operations moved back to sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully restored',
});

const plansMovedBackToSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-moved-back-to-sidebar',

	defaultMessage: 'Plans moved back to sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully restored',
});

const projectsMovedBackToSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-moved-back-to-sidebar',

	defaultMessage: 'Projects moved back to sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully restored',
});

const teamsMovedBackToSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-moved-back-to-sidebar',

	defaultMessage: 'Teams moved back to sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully restored',
});

const roadmapsMovedBackToSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-moved-back-to-sidebar',

	defaultMessage: 'Roadmaps moved back to sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully restored',
});

const a11YHideProjectsFromSidebarGalaxiaMessage = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-projects-from-sidebar-galaxia',

	defaultMessage: 'Hide spaces from sidebar',
	description:
		'Used as the text for screen-reader to support a11y for the - Hide from sidebar - menu item with added context of a menu id - Projects',
});

const a11YAlertHideProjectsFromSidebarGalaxiaMessage = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-projects-from-sidebar-galaxia',

	defaultMessage: 'Spaces have been hidden from the sidebar',
	description:
		'Used as the text for screen-reader to support a11y when the projects - menu item gets hidden',
});

const projectsHiddenFromSidebarGalaxiaMessage = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-hidden-from-sidebar-galaxia',

	defaultMessage: 'Spaces hidden from sidebar',
	description: 'A text that is displayed as a title on a flag when an item is successfully hidden',
});

const projectsMovedBackToSidebarGalaxiaMessage = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-moved-back-to-sidebar-galaxia',

	defaultMessage: 'Spaces moved back to sidebar',
	description:
		'A text that is displayed as a title on a flag when an item is successfully restored',
});

// a function that is used to extract a11y label with context
export const getA11YLabel = (
	menuId: ConfigurableMenuId,
): {
	id: string;
	defaultMessage: string;
	description: string;
} => {
	const a11YHideProjectsFromSidebarGalaxia = expVal(
		'project-terminology-refresh',
		'isEnabled',
		false,
	)
		? a11YHideProjectsFromSidebarGalaxiaMessage
		: a11YHideProjectsFromSidebar;
	switch (menuId) {
		case L1_MENU_ID.APPS:
			return a11YHideAppsFromSidebar;
		case L1_MENU_ID.GOALS:
			return a11YHideGoalsFromSidebar;
		case L1_MENU_ID.ROADMAPS:
			return a11YHideRoadmapsFromSidebar;
		case L1_MENU_ID.PLANS:
			return a11YHidePlansFromSidebar;
		case L1_MENU_ID.PROJECTS:
			return a11YHideProjectsFromSidebarGalaxia;
		case L1_MENU_ID.FILTERS:
			return a11YHideFiltersFromSidebar;
		case L1_MENU_ID.DASHBOARDS:
			return a11YHideDashboardsFromSidebar;
		case L1_MENU_ID.OPERATIONS:
			return a11YHideOperationsFromSidebar;
		case L1_MENU_ID.ASSETS:
			return a11YHideAssetsFromSidebar;
		case L1_MENU_ID.TEAMS:
			return a11YHideTeamsFromSidebar;
		default:
			return hideFromSidebar;
	}
};

// a function that is used to extract a11y alert (corresponding the aria live region)
// when an action takes place to hide a menu item
export const getA11YAlert = (
	menuId: ConfigurableMenuId,
): {
	id: string;
	defaultMessage: string;
	description: string;
} => {
	const a11YAlertHideProjectsFromSidebarGalaxia = expVal(
		'project-terminology-refresh',
		'isEnabled',
		false,
	)
		? a11YAlertHideProjectsFromSidebarGalaxiaMessage
		: a11YAlertHideProjectsFromSidebar;
	switch (menuId) {
		case L1_MENU_ID.APPS:
			return a11YAlertHideAppsFromSidebar;
		case L1_MENU_ID.GOALS:
			return a11YAlertHideGoalsFromSidebar;
		case L1_MENU_ID.ROADMAPS:
			return a11YAlertHideRoadmapsFromSidebar;
		case L1_MENU_ID.PLANS:
			return a11YAlertHidePlansFromSidebar;
		case L1_MENU_ID.PROJECTS:
			return a11YAlertHideProjectsFromSidebarGalaxia;
		case L1_MENU_ID.FILTERS:
			return a11YAlertHideFiltersFromSidebar;
		case L1_MENU_ID.DASHBOARDS:
			return a11YAlertHideDashboardsFromSidebar;
		case L1_MENU_ID.OPERATIONS:
			return a11YAlertHideOperationsFromSidebar;
		case L1_MENU_ID.ASSETS:
			return a11YAlertHideAssetsFromSidebar;
		case L1_MENU_ID.TEAMS:
			return a11YAlertHideTeamsFromSidebar;
		default:
			return a11YAlertHideDefaultFromSidebar;
	}
};

export const getNavItemHiddenFromSideBarFlagTitle = (
	menuId: ConfigurableMenuId,
): {
	id: string;
	defaultMessage: string;
	description: string;
} => {
	const projectsHiddenFromSidebarGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? projectsHiddenFromSidebarGalaxiaMessage
		: projectsHiddenFromSidebar;
	switch (menuId) {
		case L1_MENU_ID.APPS:
			return appsHiddenFromSidebar;
		case L1_MENU_ID.GOALS:
			return goalsHiddenFromSidebar;
		case L1_MENU_ID.ROADMAPS:
			return roadmapsHiddenFromSidebar;
		case L1_MENU_ID.PLANS:
			return plansHiddenFromSidebar;
		case L1_MENU_ID.PROJECTS:
			return projectsHiddenFromSidebarGalaxia;
		case L1_MENU_ID.FILTERS:
			return filtersMovedBackToSidebar;
		case L1_MENU_ID.DASHBOARDS:
			return dashboardsHiddenFromSidebar;
		case L1_MENU_ID.OPERATIONS:
			return operationsHiddenFromSidebar;
		case L1_MENU_ID.ASSETS:
			return assetsHiddenFromSidebar;
		case L1_MENU_ID.TEAMS:
			return teamsHiddenFromSidebar;
		default:
			return defaultHiddenFromSidebar;
	}
};

export const getNavItemRestoredFromSideBarFlagTitle = (
	menuId: ConfigurableMenuId,
): {
	id: string;
	defaultMessage: string;
	description: string;
} => {
	const projectsMovedBackToSidebarGalaxia = expVal(
		'project-terminology-refresh',
		'isEnabled',
		false,
	)
		? projectsMovedBackToSidebarGalaxiaMessage
		: projectsMovedBackToSidebar;
	switch (menuId) {
		case L1_MENU_ID.APPS:
			return appsMovedBackToSidebar;
		case L1_MENU_ID.GOALS:
			return goalsMovedBackToSidebar;
		case L1_MENU_ID.ROADMAPS:
			return roadmapsMovedBackToSidebar;
		case L1_MENU_ID.PLANS:
			return plansMovedBackToSidebar;
		case L1_MENU_ID.PROJECTS:
			return projectsMovedBackToSidebarGalaxia;
		case L1_MENU_ID.FILTERS:
			return filtersMovedBackToSidebar;
		case L1_MENU_ID.DASHBOARDS:
			return dashboardsMovedBackToSidebar;
		case L1_MENU_ID.OPERATIONS:
			return operationsMovedBackToSidebar;
		case L1_MENU_ID.ASSETS:
			return assetsMovedBackToSidebar;
		case L1_MENU_ID.TEAMS:
			return teamsMovedBackToSidebar;
		default:
			return defaultMovedBackToSidebar;
	}
};
